import Button from '@cloudscape-design/components/button';
import Input from '@cloudscape-design/components/input';
import Select, { SelectProps } from '@cloudscape-design/components/select';
import Badge from '@cloudscape-design/components/badge';
import Box from '@cloudscape-design/components/box';
import { TicketFilters } from '../hooks/useTicketFilters';

interface TicketSearchBarProps {
  filters: TicketFilters;
  onSearchTextChange: (text: string) => void;
  onSearchScopeChange: (scope: TicketFilters['searchScope']) => void;
  onToggleFilters: () => void;
  filtersOpen: boolean;
  activeFilterCount: number;
  matchCount: number;
}

const SCOPE_OPTIONS: SelectProps.Option[] = [
  { value: 'all', label: 'All fields' },
  { value: 'ticketId', label: 'Ticket ID' },
  { value: 'title', label: 'Title' },
  { value: 'aiSummary', label: 'AI Summary' },
];

export function TicketSearchBar({
  filters,
  onSearchTextChange,
  onSearchScopeChange,
  onToggleFilters,
  filtersOpen,
  activeFilterCount,
  matchCount,
}: TicketSearchBarProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      <Button
        variant={filtersOpen ? 'primary' : 'normal'}
        iconName="filter"
        onClick={onToggleFilters}
      >
        Filters
        {activeFilterCount > 0 && (
          <> <Badge color="blue">{activeFilterCount}</Badge></>
        )}
      </Button>

      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <Box variant="small" color="text-body-secondary" fontWeight="bold">
          Search by
        </Box>
        <div style={{ minWidth: '120px' }}>
          <Select
            selectedOption={SCOPE_OPTIONS.find((o) => o.value === filters.searchScope) ?? SCOPE_OPTIONS[0]}
            options={SCOPE_OPTIONS}
            onChange={({ detail }) => onSearchScopeChange(detail.selectedOption.value as TicketFilters['searchScope'])}
          />
        </div>
      </div>

      <div style={{ flex: 1 }}>
        <Input
          value={filters.searchText}
          placeholder="Search for tickets"
          onChange={({ detail }) => onSearchTextChange(detail.value)}
          type="search"
        />
      </div>

      <Box variant="small" color="text-body-secondary">
        <strong>{matchCount}</strong> match{matchCount !== 1 ? 'es' : ''}
      </Box>
    </div>
  );
}
